import React, { useState, useEffect } from "react";
import useAxios from "../../helpers/useAxios";
import axios from 'axios';
import { useKeycloak } from "@react-keycloak/web";

const RelatoriosProspectos = (props) => {
  const { keycloak } = useKeycloak();

  const [docsData, setDocsData] = useState();

  const { data, error, loaded } = useAxios("POST", "/Funds/list-funds-documents", {
    nif: props.nif,
    id: parseInt(props.id),
  });

  useEffect(() => {
    if (loaded && error.length === 0)
      setDocsData(data)
  }, [data]);

  const downloadDoc = (id) => {
    (async () => {
      try {
        const response = await axios({
          method: "POST",
          url: process.env.REACT_APP_URL_API + "/Funds/get-sp-file",
          responseType: 'blob',
          data : {  nif: props.nif,
            file: id, },
          headers:{
            "Content-Type":"application/json",
            "Authorization":"Bearer " + keycloak.token,
          }
        });

        const url = URL.createObjectURL(new Blob([response.data]));

        let tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.setAttribute('download', id);
        tempLink.click();
      } catch (error) {
        if (error.response.status === 401)
        {
          keycloak.logout()
        }
      }
  })();
  }

  return (
    <div className="col-md-12 bg-white rounded-4 p-3">
      <h4 className="mt-4 mb-5 me-1 ms-1">Consulte os documentos</h4>
      {docsData && (
        docsData.documents.map((d, i) => (
        <div key={i} className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
          <div className="col-10 col-info-ttl" style={{color:'#3F5B78'}}>
            {Object.keys(d)[0]}
          </div>
          <div className="col-2 text-end">
            <button
                type="button" className="btn btn-download"
                onClick={() =>  downloadDoc(Object.values(d)[0])}
              >
            </button>
          </div>
        </div>
      )))}
    </div>
  );
};

export default RelatoriosProspectos;
